import React, { useState, useRef, useEffect } from "react";
import "./UserRegistration.css";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import { API_URL } from "../../../../constants";
import validate from "./component/validate";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { FaSpinner } from "react-icons/fa";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import moment from "moment";

const UserRegisterationEdit = () => {
  const { id } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Users Registration"));
  }, []);

  let [pageLoading, setPageLoading] = useState(false);
  let [errors, setErrors] = useState({});
 
  
  const [defaultExeOptions, setDetaultExe] = useState([]);
  const [userGroupOption, setUserGroup] = useState([]);
  const [userTypeOption, setUserType] = useState([]);
  const [submitted, setSubmit] = useState(false);
  const [dateRangeOptions, setDateRangesOPtion] = useState([]);

  const initialFormData = {
    ID: "",
    Code: "",
    Name: "",
    Description: "",
    DefaultContactID: "",
    IsInActive: 0,
    IsPortalUser: true,
    Username: "",
    Password: "",
    txnPassword: "",
    UserType_166: "",
    UserGroup_167: "",
    SessionTimeout: "",
    AllowGlobalLogin: false,
    IsLocked: false,
    DateRange: "",
    FromDate: null,
    ToDate:null,
    IsAllowSaveReportGlobal: false,
    IsAllowPayrollJV: false,
    ToMyTeam: true,
    ToMyManager: true,
    ToAll: false,
    roles: [
      {
        LineNo: 1,
        role: "",
        company: "",
        branch: "",
        role_from_date: moment(new Date()).format("DD-MMM-YYYY"),
        role_to_date: null,
      },
    ],
  };
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData({
      ...formData,
      [name]: checked ? 0:1,
    });
  };
  const [formData, setFormData] = useState(initialFormData);
  const handleOnTouch = async (e) => {
    const { name, value } = e.target;
    let error = await validate(name, value, formData);
    setErrors((errors) => ({
      ...errors,
      [name]: error,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();  
    // 1. Define all validations
    const mandatoryFields = [
      "Name",
      "Description",
      "DefaultContactID",
      // "Username",
      "Password",
      "txnPassword",
      "UserType_166",
      "UserGroup_167",
      "SessionTimeout",
    ];
  
    // 2. Validate roles structure
    const validateRoles = () => {
      if (!formData.roles || formData.roles.length === 0) {
        return { status: true, message: "At least one role is required" };
      }
  
      const invalidRoles = formData.roles.filter(role => 
        !role.role || 
        !role.company || 
        !role.branch || 
        !role.role_from_date 
        // || 
        // !role.role_to_date
      );
  
      if (invalidRoles.length > 0) {
        return { 
          status: true, 
          message: `Please fill all fields in roles tab ${invalidRoles[0].LineNo || ''}`
        };
      }
  
      return { status: false };
    };
     // 3. Run all validations
     try {
      // Validate main fields
      for (const field of mandatoryFields) {
        const error = await validate(field, formData[field], formData);
        if (error.status) {
          toast.error(error.message || `${field} is required`);
          setErrors(prev => ({ ...prev, [field]: error }));
          return;
        }
      }
  
      // Validate roles
      const rolesError = validateRoles();
      if (rolesError.status) {
        toast.error(rolesError.message);
        return;
      }
  
      // 4. Only submit if ALL validations pass
      setSubmit(true);
        let response = await PostServiceCaller(
          API_URL + `rujul/users/${id}`,
          formData,
          "put"
        );
            if (response.data.status === "success") {
                toast.success(response.data.message);
              setTimeout(()=>{  navigate('/rujul/user-list')},2000)
              } else {
                toast.error(response.data.message || "Submission failed");
              }
          
            } catch (error) {
              console.error("Submission error:", error);
              toast.error(error.message || "An error occurred while submitting");
            } finally {
              setSubmit(false);
            }
  };

  useEffect(() => {
    fetchData();

    if (id) {
      fetchUserShowApi(id);
    }
  }, [id]);
  const fetchData = async () => {
    const response = await GetServiceCaller(`${API_URL}registration-details`);
    // Setting user type
    let userTypeOpt = response?.data?.user_types?.map((option) => ({
      value: option.value,
      label: option.text,
    }));
    setUserType(userTypeOpt);
    // Setting user group
    let userGroupOpt = response?.data?.user_group?.map((option) => ({
      value: option.value,
      label: option.text,
    }));
    setUserGroup(userGroupOpt);
    // setting defaultExe
    let defaultExeOpt = response?.data?.defaultExe.map((option) => ({
      value: option.value,
      label: option.Name,
    }));
    setDetaultExe(defaultExeOpt);
    let dateRangeOpt = response?.data?.dateRanges.map((option) => ({
      value: option.value,
      label: option.text,
    }));
    setDateRangesOPtion(dateRangeOpt);
  };

  const fetchUserShowApi = async (userID) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}rujul/users/${userID}`
      );
      if (response.status === 200) {
        const cleanedData = response?.data?.user;
        const rolesData = response?.data?.roles;

        const formEditData = {
          ID: cleanedData?.ID,
          Code: cleanedData?.Code,
          Name: cleanedData?.Name,
          Description: cleanedData?.Description||"",
          DefaultContactID: cleanedData?.DefaultContactID||"",
          IsInActive: cleanedData?.IsInActive,
          IsPortalUser: cleanedData?.IsPortalUser,
          Username: cleanedData?.Username,
          Password: cleanedData?.Password,
          txnPassword: cleanedData?.Password,
          UserType_166: cleanedData?.UserType_166,
          UserGroup_167: cleanedData?.UserGroup_167,
          SessionTimeout: cleanedData?.SessionTimeout,
          AllowGlobalLogin: cleanedData?.AllowGlobalLogin,
          IsLocked: cleanedData?.IsLocked,
          DateRange: cleanedData?.DateRange,
          FromDate: cleanedData?.FromDate
            ? moment(cleanedData.FromDate).format("DD-MMM-YYYY")
            : "",
          ToDate:
            (cleanedData?.ToDate &&
              moment(cleanedData.ToDate).format("DD-MMM-YYYY")) ||
            "",
          IsAllowSaveReportGlobal: cleanedData?.IsAllowSaveReportGlobal,
          IsAllowPayrollJV: cleanedData?.IsAllowPayrollJV,
          IsTimeBoundUser: cleanedData?.IsTimeBoundUser,
          StartDate: cleanedData?.StartDate,
          EndDate: cleanedData?.EndDate,
          ToMyTeam: cleanedData?.ToMyTeam,
          ToMyManager: cleanedData?.ToMyManager,
          ToAll: cleanedData?.ToAll,
          roles: rolesData?.map((ele, index) => ({
            canBeDelete:1,
            LineNo: index + 1,
            role: ele?.RoleID,
            company: ele?.CompanyID,
            branch: ele?.BranchID,
            role_from_date:
              (ele?.FromDate && moment(ele?.FromDate).format("DD-MMM-YYYY")) ||
              "",
            role_to_date:
              (ele?.ToDate && moment(ele?.ToDate).format("DD-MMM-YYYY")) || "",
          })),
        };
        setFormData(formEditData);
      } else {
        console.error(
          "Failed to fetch partner Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Partner Master:", error);
    }
  };
  const handleSelect = async (selectedOption, name) => {
    // Update formData with the selected value for the SkillID
const selectedValue = selectedOption.value 
    if (name === "DefaultContactID") {
      fetchEmpDetails(selectedValue);
    }
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: selectedOption.value };
      // Trigger validation for the specific field after updating
      // validateField(name, updatedData);
      return updatedData;
    });
  };
 const fetchEmpDetails = async (contactId) => {
    try {
      let response;

      response = await GetServiceCaller(
        `${API_URL}get-employee-info?ID=${contactId}`
      );

      if (response?.status == 200) {
        setFormData((prevdata) => ({
          ...prevdata,
          Username: response?.data?.userDetails?.Email,
        }));
      }
    } catch (error) {
      console.error("Fetching Api Error", error);
    }
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));
    // validateField(name, value); // Validate this field on change
  };

  const handleSelectRoleChange = (selectedOption, index, name) => {
    const updatedLines = [...formData.roles];
    updatedLines[index] = {
      ...updatedLines[index],
      [name]: selectedOption.value,
    };

    setFormData((prevState) => ({
      ...prevState,
      roles: updatedLines,
    }));
  };

  const handleRoleChange = (event, index) => {
    const { name, value } = event.target;
    const updatedLines = [...formData.roles];
    updatedLines[index] = {
      ...updatedLines[index],
      [name]: value,
    };

    setFormData((prevState) => ({
      ...prevState,
      roles: updatedLines,
    }));
  };
  const addRow = () => {
    // Check if all existing rows are filled
    const hasEmptyFields = formData.roles.some(row => 
      !row.role || 
      !row.company || 
      !row.branch || 
      !row.role_from_date 
      // || 
      // !row.role_to_date
    );
  
    if (hasEmptyFields) {
      toast.error("Please fill all fields in the current rows before adding a new one.");
      return; // Exit early if validation fails
    }
  
    // Calculate the next LineNo
    const newLineNo = formData.roles.reduce((max, row) => Math.max(max, row.LineNo || 0), 0) + 1;
  
    // Add new row only if validation passes
    setFormData((prevState) => ({
      ...prevState,
      roles: [
        ...prevState.roles,
        {
          LineNo: newLineNo,
          role: "",
          company: "",
          branch: "",
          role_from_date:moment(new Date()).format("DD-MMM-YYYY"),
          role_to_date: "",
        },
      ],
    }));
  };

  const deleteRow = (index) => {
    const updatedLines = formData.roles.filter((_, i) => i !== index);
    setFormData((prevState) => ({
      ...prevState,
      roles: updatedLines,
    }));
  };

  const [companyOptions, setCompanyOptions] = useState([]);
  const [branchOption, setBranchOptions] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);

  const fetchCompanyOptions = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}fetch-companies`);
      const companyOpt = response.data.companies.map((option) => ({
        label: option.text,
        value: option.value,
      }));
      setCompanyOptions(companyOpt);
    } catch (error) {
      console.error("Error fetching code options:", error);
    }
  };
  const fetchRoleOptions = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}fetch-roles`);
      const roleOpt = response.data.roles.map((option) => ({
        value: option.value,
        label: option.text,
      }));
      setRoleOptions(roleOpt);
    } catch (error) {
      console.error("Error fetching code options:", error);
    }
  };
  useEffect(() => {
    fetchCompanyOptions();
    fetchRoleOptions();
  }, []);

  useEffect(() => {
    // Get unique company IDs
    const companyIds = [...new Set(formData?.roles?.map(role => role?.company).filter(Boolean))];
    
    // Fetch branches for each unique company
    companyIds?.forEach(companyId => {
      fetchBranchOptions(companyId);
    });
  }, [formData?.roles]);
  
  // Add a ref to track the current request
  const currentRequestRef = useRef(null);
  
  const fetchBranchOptions = async (company_id) => {
    try {
      // Cancel previous request if it exists
      if (currentRequestRef.current) {
        currentRequestRef.current.abort();
      }
      
      // Create new AbortController for current request
      const controller = new AbortController();
      currentRequestRef.current = controller;
      
      let data = JSON.stringify({
        company_id: company_id,
      });
      
      let response = await PostServiceCaller(
        `${API_URL}fetch-branch`,
        data,
        "post",
        { signal: controller.signal }
      );      
      const branchOpt = response.data.branch.map((option) => ({
        value: option.value,
        label: option.text,
      }));
      
      setBranchOptions(branchOpt);
      currentRequestRef.current = null;
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error("Error fetching code options:", error);
      }
    }
  };

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <div className="Container">
        <form onSubmit={handleSubmit} id="formOne" className="rounded mt-2 bg-white">
            <ul className="nav nav-tabs overflow" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  style={{ color: "#2F2E4B" }}
                  id="general-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#general"
                  type="button"
                  role="tab"
                  aria-controls="general"
                  aria-selected="true"
                >
                  General Details
                  <span className="text-danger">
                    {formData.job_title?.label.trim() &&
                      `: ${formData.job_title.label}`}
                  </span>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  style={{ color: "#2F2E4B" }}
                  id="login-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#login"
                  type="button"
                  role="tab"
                  aria-controls="login"
                  aria-selected="false"
                >
                  Login Credentials
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  style={{ color: "#2F2E4B" }}
                  id="report-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#report"
                  type="button"
                  role="tab"
                  aria-controls="report"
                  aria-selected="false"
                >
                  Report Data Settings & Login Time/Announcement Setting's
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  style={{ color: "#2F2E4B" }}
                  id="role-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#role"
                  type="button"
                  role="tab"
                  aria-controls="role"
                  aria-selected="false"
                >
                  Role Details
                </button>
              </li>
            </ul>
            <div className="tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id="general"
                role="tabpanel"
                aria-labelledby="general-tab"
              >
                <div className="container-fluid mt-2">
                  <div className="row mt-2">
                    <div class="col-md-3">
                      <div class="form-group">
                        <label className="form-label">Code</label>
                        <input
                          type="text"
                          name="Code"
                          placeholder="Code"
                          className="form-control"
                          disabled
                          value={formData.Code}
                          onChange={(e) => handleChange(e)}
                          readOnly={true}
                        />
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label className="form-label">
                          Name <span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          name="Name"
                          placeholder="Name"
                          className={
                            errors?.Name?.message
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          value={formData.Name}
                          onChange={(e) => handleChange(e)}
                          onBlur={handleOnTouch}
                        />
                        <span class="error">{errors?.Name?.message}</span>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="">
                        <label for="taxId" class="form-label">
                          {" "}
                        Employee <span className="required">*</span>
                        </label>
                        <Select
                          name="DefaultContactID"
                          value={defaultExeOptions?.find(
                            (o) => o.value === formData.DefaultContactID
                          )}
                          onChange={(selectedOption, action) =>
                            handleSelect(selectedOption, action.name)
                          }
                          options={[
                            { value: "", label: "Select..." },
                            ...defaultExeOptions,
                          ]}
                        />
                        <span class="error">
                          {errors?.DefaultContactID?.message}
                        </span>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label className="form-label">
                          Description
                        </label>
                        <textarea
                          type="text"
                          placeholder="Description"
                          className="form-control"
                          id="Description"
                          name="Description"
                          value={formData.Description}
                          onChange={(e) => handleChange(e)}
                          onBlur={handleOnTouch}
                        ></textarea>
                        <span class="error">
                          {errors?.Description?.message}
                        </span>
                      </div>
                    </div>
                  
                  </div>
                  <div className="row">
                      <div class="col-md-6">
                        <div className="d-flex align-items-left">
                          <div className="form-check me-3">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="IsInActive"
                              name="IsInActive"
                              checked={formData.IsInActive == 0 ?true:false }
                              onChange={handleCheckboxChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="is_in_active"
                            >
                              Active
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="IsPortalUser"
                              name="IsPortalUser"
                              checked={formData.IsPortalUser}
                              onChange={handleCheckboxChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="is_portal_user"
                            >
                              IsPortalUser
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>

              <div
                className="tab-pane fade show"
                id="login"
                role="tabpanel"
                aria-labelledby="login-tab"
              >
                <div className="row mt-2">
                  <div className="col-md-3">
                    <div class="form-group">
                      <label htmlFor="clientName" className="form-label">
                        Username <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        disabled
                        placeholder="Username"
                        className={
                          errors?.Username?.message
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        id="Username"
                        name="Username"
                        value={formData.Username}
                        onChange={(e) => handleChange(e)}
                        onBlur={handleOnTouch}
                      />
                      <span class="error">{errors?.Username?.message}</span>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div class="form-group">
                      <label htmlFor="ndaMsaRef" className="form-label">
                        Password <span className="required">*</span>
                      </label>
                      <input
                        type="Password"
                        placeholder="Password"
                        className={
                          errors?.Password?.message
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        id="Password"
                        name="Password"
                        autoComplete="new-password"
                        value={formData.Password}
                        onChange={(e) => handleChange(e)}
                        onBlur={handleOnTouch}
                      />
                      <span class="error">{errors?.Password?.message}</span>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div class="form-group">
                      <label htmlFor="txnPassword" className="form-label">
                        {" "}
                        Confirm Password <span className="required">
                          *
                        </span>{" "}
                      </label>
                      <input
                        type="password"
                        placeholder="Confirm Password"
                        className={
                          errors?.txnPassword?.message
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        id="txnPassword"
                        name="txnPassword"
                        value={formData.txnPassword}
                        onChange={(e) => handleChange(e)}
                        onBlur={handleOnTouch}
                      />
                      <span class="error">{errors?.txnPassword?.message}</span>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div class="">
                      <label for="taxId" class="form-label">
                        User Type
                        <span className="required">*</span>
                      </label>
                      <Select
                        name="UserType_166"
                        value={userTypeOption?.find(
                          (o) => o.value === formData.UserType_166
                        )}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        options={[
                          { value: "", label: "Select..." },
                          ...userTypeOption,
                        ]}
                      />
                      <span class="error">{errors?.UserType_166?.message}</span>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <div class="">
                      <label for="taxId" class="form-label">
                        User Group
                        <span className="required">*</span>
                      </label>
                      <Select
                        name="UserGroup_167"
                        value={userGroupOption.find(
                          (o) => o.value === formData.UserGroup_167
                        )}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                        options={[
                          { value: "", label: "Select..." },
                          ...userGroupOption,
                        ]}
                      />
                      <span class="error">{errors?.user_group?.message}</span>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div class="form-group">
                      <label htmlFor="Session Timeout" className="form-label">
                        Session Timeout (Minutes)<span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Session Timeout"
                        className={
                          errors?.SessionTimeout?.message
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        id="SessionTimeout"
                        name="SessionTimeout"
                        value={formData.SessionTimeout}
                        onChange={(e) => handleChange(e)}
                        onBlur={handleOnTouch}
                      />
                      <span class="error">
                        {errors?.SessionTimeout?.message}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-6 mt-4">
                    <div className="d-flex align-items-left">
                      <div className="form-check mx-1">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="AllowGlobalLogin"
                          name="AllowGlobalLogin"
                          checked={formData.AllowGlobalLogin}
                          onChange={handleCheckboxChange}
                          isClearable
                        />
                        <label
                          className="form-check-label"
                          htmlFor="allow_global_login"
                        >
                          Allow Global Login
                        </label>
                      </div>
                      <div className="form-check mx-1">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="IsLocked"
                          name="IsLocked"
                          checked={formData.IsLocked}
                          onChange={handleCheckboxChange}
                          isClearable
                        />
                        <label className="form-check-label" htmlFor="IsLocked">
                          As Locked
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="tab-pane fade show"
                id="report"
                role="tabpanel"
                aria-labelledby="report-tab"
              >
                <div className="row mt-2">
                  <div className="col-md-3">
                    <div class="">
                      <label htmlFor="gstvatDate" className="form-label">
                        Date Range
                      </label>
                      <Select
                        options={dateRangeOptions}
                        class="form-control"
                        id="date_range"
                        name="DateRange"
                        value={dateRangeOptions?.find(
                          (o) => o.value === formData.DateRange
                        )}
                        onChange={(selectedOption, action) =>
                          handleSelect(selectedOption, action.name)
                        }
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div class="form-group">
                      <label htmlFor="gstvatFrom" className="form-label">
                        From Date
                      </label>
                      <CustomDatePicker
                        showPopperArrow
                        showIcon
                        icon="fa fa-calendar"
                        className="form-control"
                        placeholderText="From Date"
                        format="d-MM-YYYY"
                        name="FromDate"
                        value={formData.FromDate}
                        id="FromDate"
                        handleChange={(e) => handleChange(e)}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div class="form-group">
                      <label htmlFor="gstvatTo" className="form-label">
                        To Date
                      </label>
                      <CustomDatePicker
                        showYearDropdown
                        showPopperArrow
                        showIcon
                        icon="fa fa-calendar"
                        className="form-control"
                        placeholderText="To Date"
                        format="d-MM-YYYY"
                        name="ToDate"
                        value={formData.ToDate}
                        id="ToDate"
                        handleChange={(e) => handleChange(e)}
                      />
                    </div>
                  </div>
                  <div className="col-md-3 mt-4">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="IsAllowSaveReportGlobal"
                        name="IsAllowSaveReportGlobal"
                        checked={formData.IsAllowSaveReportGlobal}
                        onChange={handleCheckboxChange}
                        isClearable
                      />
                      <label
                        className="form-check-label"
                        htmlFor="IsAllowSaveReportGlobal"
                      >
                        Allow Save Global Report
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="IsAllowPayrollJV"
                        name="IsAllowPayrollJV"
                        checked={formData.IsAllowPayrollJV}
                        onChange={handleCheckboxChange}
                        isClearable
                      />
                      <label
                        className="form-check-label"
                        htmlFor="allow_payroll_jv"
                      >
                        Allow Payroll JV
                      </label>
                    </div>
                  </div>
                </div>
                {/* Login Time Announcement Settings */}

                <div className="row mt-4">
                  <div className="col-md-2">
                    <div className="form-check  mx-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="ToMyTeam"
                        name="ToMyTeam"
                        checked={formData.ToMyTeam}
                        onChange={handleCheckboxChange}
                      />
                      <label className="form-check-label" htmlFor="ToMyTeam">
                        To My Team
                      </label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check  mx-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="ToMyManager"
                        name="ToMyManager"
                        checked={formData.ToMyManager}
                        onChange={handleCheckboxChange}
                      />
                      <label className="form-check-label" htmlFor="ToMyManager">
                        To My Manager
                      </label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-check  mx-1">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="ToAll"
                        name="ToAll"
                        checked={formData.ToAll}
                        onChange={handleCheckboxChange}
                      />
                      <label className="form-check-label" htmlFor="ToAll">
                        To All
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="tab-pane fade show"
                id="role"
                role="tabpanel"
                aria-labelledby="role-tab"
              >
                <div className="row mt-2">
                  <div className="text-end">
                    <button
                      type="button"
                      onClick={addRow}
                      className="custom-btn"
                    >
                      <i className="fa fa-plus"></i>&nbsp;Add
                    </button>
                  </div>
                  <div className="table-responsive poc-head rounded mt-2">
                    <table id="poctable_head" className="table table-bordered">
                      <thead className="text-center">
                        <tr className="head">
                          <th>Sr.No.</th>
                          <th>Role<span className="required">*</span></th>
                          <th>Company<span className="required">*</span></th>
                          <th>Branch<span className="required">*</span></th>
                          <th>From Date<span className="required">*</span></th>
                          <th>To Date</th>
                          <th>Delete</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData?.roles?.map((row, rowIndex) => (
                          <tr key={rowIndex}>
                            <td>{rowIndex + 1}</td>
                            <td>
                              <Select
                                styles={{
                                  container: (base) => ({
                                    ...base,
                                    width: "200px",
                                  }),
                                }}
                                autoSize={false}
                                menuPosition="fixed"
                                className="poc-select"
                                options={[
                                  { value: "", label: "Select..." },
                                  ...roleOptions,
                                ]}
                                value={roleOptions.find(
                                  (o) => o.value === row.role
                                )}
                                name="role"
                                placeholder="Select Role"
                                onChange={(selectedOption) =>
                                  handleSelectRoleChange(
                                    selectedOption,
                                    rowIndex,
                                    "role"
                                  )
                                }
                              />
                            </td>
                            <td>
                              <Select
                                styles={{
                                  container: (base) => ({
                                    ...base,
                                    width: "260px",
                                  }),
                                }}
                                options={[
                                  { label: "Select...", value: "" },
                                  ...companyOptions,
                                ]}
                                autoSize={false}
                                menuPosition="fixed"
                                className="poc-select"
                                name="company"
                                placeholder="company"
                                value={companyOptions.find(
                                  (o) => o.value === row.company
                                )}
                                onChange={(selectedOption) => {
                                  handleSelectRoleChange(
                                    selectedOption,
                                    rowIndex,
                                    "company"
                                  );
                                  fetchBranchOptions(selectedOption.value);
                                }}
                              />
                            </td>
                            <td>
                              <Select
                                styles={{
                                  container: (base) => ({
                                    ...base,
                                    width: "160px",
                                  }),
                                }}
                                options={[
                                  { value: "", label: "Select..." },
                                  ...branchOption,
                                ]}
                                autoSize={false}
                                menuPosition="fixed"
                                name="branch"
                                placeholder="Branch"
                                value={branchOption.find(
                                  (o) => o.value === row.branch
                                )}
                                onChange={(selectedOption) =>
                                  handleSelectRoleChange(
                                    selectedOption,
                                    rowIndex,
                                    "branch"
                                  )
                                }
                              />
                            </td>
                            <td>
                              <CustomDatePicker
                                autoComplete="off"
                                showPopperArrow
                                name="role_from_date"
                                className="form-control"
                                placeholderText="From Date"
                                showIcon
                                icon="fa fa-calendar"
                                value={row.role_from_date}
                                handleChange={(e) =>
                                  handleRoleChange(e, rowIndex)
                                }
                              />
                            </td>
                            <td>
                              <CustomDatePicker
                                autoComplete="off"
                                showPopperArrow
                                name="role_to_date"
                                className="form-control"
                                placeholderText="To Date"
                                showIcon
                                icon="fa fa-calendar"
                                value={row.role_to_date}
                                handleChange={(e) =>
                                  handleRoleChange(e, rowIndex)
                                }
                              />
                            </td>
                           <td className="text-center">
  <i
    className={`fa fa-trash-o mt-2 icons ${row.canBeDelete ? "disabled-icon" : ""}`}
    onClick={() => {
      if (!row.canBeDelete) {
        deleteRow(rowIndex);
      }
    }}
    style={{ cursor: !row.canBeDelete ? "pointer" : "not-allowed" }}
  ></i>
</td>

                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end mt-2">
              <div className="d-flex">
                <div>
                  <button
                    type="button"
                    className="cancel-btn me-2"
                    onClick={() => navigate(`/rujul/user-list`)}
                  >
                    Cancel
                  </button>
                </div>
                <div>
                  <button
                    disabled={submitted ? true : false}
                    onClick={handleSubmit}
                    type=""
                    className=" custom-btn"
                  >
                    {submitted ? <FaSpinner class="sm-spinner" /> : "Submit"}
                  </button>
                </div>
              </div>
            </div>
        </form>
      </div>
    );
  }
};

export default UserRegisterationEdit;
